module.exports = __webpack_public_path__ + "static/media/kroppstemperatur.a8595a7b.mp3";